import { Typography, Stack, Box } from '@mui/material';

import { useWorkspace } from '@/contexts/useWorkspace';
import { PanelSize } from '@/contexts/workspaceContext';
import { dayjs, DATE_TIME_FORMAT } from '@/utils/dayjs';

import type { LogEntry } from './types';

import { Panels } from '../../panels/panels';

const colors = {
  INFO: 'var(--mui-palette-info-main)',
  WARN: 'var(--mui-palette-warning-main)',
  ERROR: 'var(--mui-palette-error-main)',
  UNKNOWN: 'var(--mui-palette-text-disabled)',
};

export const SeverityCircle = ({
  severity,
}: {
  severity: keyof typeof colors;
}) => (
  <Box
    height='8px'
    width='8px'
    minWidth='8px'
    minHeight='8px'
    borderRadius='50%'
    sx={{ background: colors[severity] }}
  />
);

export const LogTimeCell = ({ entry }: { entry: LogEntry }) => {
  const { rightPanel } = useWorkspace();

  return (
    <Stack direction='row' alignItems='center' gap='12px'>
      <SeverityCircle severity={entry.severity} />
      <Typography
        className='underline hover:cursor-pointer hover:text-[var(--mui-palette-text-secondary)]'
        onClick={() => {
          rightPanel.setComponent({
            panel: Panels.LogSpaceCard,
            props: {
              entry,
              onClose: () => rightPanel.setIsOpen(false),
            },
          });

          const shouldOpen =
            !rightPanel.isOpen ||
            (!!rightPanel.Component?.props &&
              'entry' in rightPanel.Component.props &&
              'id' in rightPanel.Component.props.entry &&
              rightPanel.Component.props.entry.id !== entry.id);

          rightPanel.setIsOpen(shouldOpen, PanelSize.Large);
        }}
      >
        {dayjs.utc(entry.eventTime).format(DATE_TIME_FORMAT)}
      </Typography>
    </Stack>
  );
};
